module.exports = __webpack_public_path__ + "static/media/sage.e9c9776b.png";